
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BrandLogo',
  props: {
    tailwindClass: { type: String, default: '' },
    logoType: { type: String, default: 'primary' },
  },
  computed: {
    orgName() {
      const hostname = window.location.hostname
      if (hostname.includes('fivestardev.com')) return 'fivestar'
      if (hostname.includes('simplesoft.net')) return 'simplesoft'
      return 'ingage'
    },
    sourceLogo() {
      try {
        return require(`@/assets/logos/${this.orgName}-logo-${this.logoType}.svg`)
      } catch {
        return require(`@/assets/logos/${this.orgName}-logo-primary.svg`)
      }
    },
  },
})
